"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const class_validator_1 = require("class-validator");
const Customer_1 = __importDefault(require("./Customer"));
const OfficeFolder_1 = __importDefault(require("./OfficeFolder"));
const Resource_1 = __importDefault(require("../Resource"));
const classTransformer_1 = require("../classTransformer");
class Note extends Resource_1.default {
    constructor() {
        super(...arguments);
        this.content = null;
        this.created_at = null;
        this.updated_at = null;
    }
}
exports.default = Note;
__decorate([
    (0, classTransformer_1.Expose)(),
    __metadata("design:type", String)
], Note.prototype, "uid", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    __metadata("design:type", Object)
], Note.prototype, "content", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, class_validator_1.IsDate)(),
    __metadata("design:type", Object)
], Note.prototype, "created_at", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, class_validator_1.IsDate)(),
    __metadata("design:type", Object)
], Note.prototype, "updated_at", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, classTransformer_1.Type)(() => Customer_1.default),
    __metadata("design:type", Customer_1.default)
], Note.prototype, "customer", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, classTransformer_1.Type)(() => OfficeFolder_1.default),
    __metadata("design:type", OfficeFolder_1.default)
], Note.prototype, "folder", void 0);
